import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const LocationIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    {/* Pin marker */}
    <Path d="M12 25L12 25C12 25 21 15.5 21 9.5C21 4.25 17 1 12 1C7 1 3 4.25 3 9.5C3 15.5 12 25 12 25Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    {/* Inner circle */}
    <Path d="M12 13C14 13 15.5 11.5 15.5 9.5C15.5 7.5 14 6 12 6C10 6 8.5 7.5 8.5 9.5C8.5 11.5 10 13 12 13Z" stroke={color} strokeWidth="2" />
  </Svg>
);

LocationIcon.displayName = 'LocationIcon';
